import React from 'react';

const MonthlyFooter = ({
  onCancel,
  onSaveDraft,
  onCreateRota,
  saving = false,
  creating = false,
}) => {

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
      return;
    }

    window.history.back();
  };

  return (
    <div
      className="
        flex
        flex-col-reverse
        sm:flex-row
        items-stretch
        sm:items-center
        justify-between
        gap-3
        pt-2
        pb-4
      "
    >

      {/* Left Side */}
      <div>
        <button
          type="button"
          onClick={handleCancel}
          disabled={saving || creating}
          className="
            w-full
            sm:w-auto
            min-w-[110px]
            px-5
            py-2.5
            bg-white
            border
            border-gray-300
            rounded-md
            text-xs
            font-bold
            text-gray-700
            hover:bg-gray-50
            hover:border-gray-400
            disabled:opacity-50
            disabled:cursor-not-allowed
            transition
          "
        >
          Cancel
        </button>
      </div>

      {/* Right Side */}
      <div className="flex flex-col sm:flex-row gap-3">

        {/* Save Draft */}
        <button
          type="button"
          onClick={onSaveDraft}
          disabled={saving || creating}
          className="
            w-full
            sm:w-auto
            min-w-[125px]
            px-5
            py-2.5
            bg-white
            border
            border-blue-300
            rounded-md
            text-xs
            font-bold
            text-blue-600
            hover:bg-blue-50
            hover:border-blue-400
            disabled:opacity-50
            disabled:cursor-not-allowed
            transition
          "
        >
          {saving ? 'Saving...' : 'Save as Draft'}
        </button>

        {/* Create Rota */}
        <button
          type="button"
          onClick={onCreateRota}
          disabled={saving || creating}
          className="
            w-full
            sm:w-auto
            min-w-[140px]
            px-6
            py-2.5
            bg-blue-600
            border
            border-blue-600
            rounded-md
            text-xs
            font-bold
            text-white
            hover:bg-blue-700
            hover:border-blue-700
            shadow-sm
            disabled:opacity-50
            disabled:cursor-not-allowed
            transition
          "
        >
          {creating ? 'Creating...' : 'Create Rota'}
        </button>

      </div>
    </div>
  );
};

export default MonthlyFooter;